import { IppicaScommesseType, Stato } from 'features/ippica/types';
import { RootState, useAppDispatch, useTypedSelector } from 'lib/centralStore';
import { selectCodiceStatoAvvenimento, selectIppicaRaceDetail } from 'features/ippica/selectors';

import { IppicaEmpty } from '../ippicaEmpty';
import { IppicaScommesseTableAntepostRow } from '../ippicaScommesseTableAntepostRow';
import { isDifferentStatoScommessaByKey } from 'features/ippica/functions';
import { setScommesseType } from 'features/ippica/ippicaSlice';
import styles from './IppicaScommesseAntepostRenderer.module.scss';
import { useGetLabelByKey } from 'hooks/useLingUI';
import { useSelector } from 'react-redux';
import useWindowSize from 'hooks/useWindowSize';

export const IppicaScommesseAntepostRenderer = () => {
  const dispatch = useAppDispatch();
  dispatch(setScommesseType(IppicaScommesseType.QF));

  const { isMobile } = useWindowSize();

  const labelVincente = useGetLabelByKey('vincente')!;
  const labelNumeriIndicativi = useGetLabelByKey('numeri-indicativi')!;

  const codiceStatoAvvenimento = useTypedSelector(selectCodiceStatoAvvenimento);
  const { cavalliKeyList } = useTypedSelector(selectIppicaRaceDetail);
  const { isOpen } = useSelector((store: RootState) => store.carrello);
  return (
    <div>
      {codiceStatoAvvenimento && isDifferentStatoScommessaByKey(codiceStatoAvvenimento, Stato.Annullata) ? (
        <>
          {!isMobile && !!cavalliKeyList?.length && (
            <p className={`${styles.tableHeader} ${!isOpen ? styles.withMarginRight : ''}`}>
              <span className={styles.text}>{labelVincente}</span>
            </p>
          )}

          <div className={`${styles.table} ${!isOpen ? styles.withMarginRight : ''}`}>
            {!!cavalliKeyList?.length &&
              cavalliKeyList.map((keyCavallo, index) => {
                return (
                  <IppicaScommesseTableAntepostRow key={keyCavallo} keyCavallo={keyCavallo} indexCavallo={index} />
                );
              })}
          </div>
          <p className={styles.labelInfo}>{labelNumeriIndicativi}</p>
        </>
      ) : (
        <IppicaEmpty hasMarginRight={!isOpen}>
          <span>Non ci sono dati disponibili</span>
        </IppicaEmpty>
      )}
    </div>
  );
};
